/* istanbul ignore file */
import Checkbox from './Checkbox';

export default Checkbox;
